import Constants from '../../constants';
import { ACTION_SUCCESS } from '../../constants/action-status';
import { AdminConfigRecord } from '../../records';

export const DEFAULT_STATE = new AdminConfigRecord();

export default function adminPageReducer(state = DEFAULT_STATE, action) {
	switch (action.type) {
		case `${Constants.UPDATE_ADMIN_CONFIG}_${ACTION_SUCCESS}`:
		case `${Constants.FETCH_ADMIN_CONFIG}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				state.set('notificationsEnabled', action.payload.results.notificationsEnabled);
				return state;
			});
		default:
			return state;
	}
}
